import React from "react";
import { Bus } from "lucide-react";

/**
 * YAZTUR brand mark — orange squared tile + wordmark.
 * Used in sidebar, login and any header slot.
 */
export function YazturLogo({ size = 40, showText = true, subtitle = "Filo Bakım & Prim" }) {
  const px = typeof size === "number" ? `${size}px` : size;
  return (
    <div className="flex items-center gap-3" data-testid="yaztur-logo">
      <div
        className="relative flex items-center justify-center rounded-md shrink-0"
        style={{
          width: px,
          height: px,
          background: "var(--y-accent)",
        }}
        aria-label="YAZTUR"
      >
        <Bus
          className="text-[color:var(--y-accent-fg)]"
          style={{ width: "58%", height: "58%" }}
          strokeWidth={2.2}
        />
      </div>
      {showText && (
        <div className="leading-tight min-w-0">
          <div
            className="font-heading"
            style={{
              fontFamily: "'Barlow Semi Condensed', sans-serif",
              fontWeight: 700,
              fontSize: size * 0.5,
              letterSpacing: "0.06em",
              color: "var(--y-text)",
            }}
          >
            YAZTUR
          </div>
          <div
            className="truncate"
            style={{
              fontSize: 12,
              color: "var(--y-label)",
              letterSpacing: "0.02em",
              marginTop: 1,
            }}
          >
            {subtitle}
          </div>
        </div>
      )}
    </div>
  );
}

/** Kept for backwards-compat imports; renders nothing in the new dark theme. */
export function BrandStripe() {
  return null;
}
